module.exports = __webpack_public_path__ + "fonts/summernote.82fa597f.ttf";